import CreateAdminForm from './component'

export default CreateAdminForm
